import { Users } from "lucide-react"

interface TeamMember {
  role: string
  expertise: string
  bio: string
}

const teamMembers: TeamMember[] = [
  {
    role: "Founder & Visionary",
    expertise: "Social Impact & AI Innovation",
    bio: "A leader with deep experience in nonprofit tech and AI, driving the future of corporate volunteering at scale."
  },
  {
    role: "Chief Technology Officer",
    expertise: "AI, Automation & Scalable Systems",
    bio: "Expert in AI-driven automation, ensuring CauseConnect delivers a seamless, data-powered experience for nonprofits."
  },
  {
    role: "Head of Growth & GTM Strategy",
    expertise: "B2B SaaS & Nonprofit Engagement",
    bio: "Bringing decades of experience in growth, partnerships, and scaling nonprofit solutions for global impact."
  },
  {
    role: "Content & Marketing Strategist",
    expertise: "Storytelling & Engagement",
    bio: "Crafting compelling narratives that drive nonprofit adoption and corporate impact, turning cause into action."
  },
  {
    role: "AI & Product Innovation Lead",
    expertise: "Human-Centered AI & User Experience",
    bio: "Building intuitive AI-powered tools that simplify nonprofit workflows and enhance engagement."
  },
  {
    role: "Brand & UX Designer",
    expertise: "Visual Identity & User Experience",
    bio: "Creating a frictionless, high-impact platform experience that empowers nonprofits to scale their reach."
  }
]

export default function TeamPage() {
  return (
    <div className="container mx-auto py-12 px-4">
      <div className="text-center mb-12">
        <div className="flex items-center justify-center mb-4">
          <Users className="h-10 w-10 text-primary" />
        </div>
        <h1 className="text-4xl font-heading font-bold text-gray-900 mb-4">
          The Team Behind CauseConnect
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          A team of volunteers, engineers, and impact strategists, working in stealth mode to redefine how nonprofits engage to scale impact.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {teamMembers.map((member, index) => (
          <div 
            key={index}
            className="bg-white rounded-lg shadow-md overflow-hidden transition-transform hover:scale-105 p-6"
          >
            <h3 className="text-xl font-heading font-semibold text-gray-900 mb-1">
              {member.role}
            </h3>
            <p className="text-primary font-medium mb-1">
              {member.expertise}
            </p>
            <p className="text-gray-600">
              {member.bio}
            </p>
          </div>
        ))}
      </div>
      
      <div className="text-center mt-12">
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          We're building in stealth mode but are always open to feedback. Ping us at <a href="mailto:support@causeconnect.ai">support@causeconnect.ai</a>
        </p>
      </div>
    </div>
  )
}
